export default function ContentFirst({ verticalTabsState }) {
  return (
    <div
      className={`content-1 overflow-hidden max-h-0 transition-opacity duration-[0.2s] ease-linear ${
        verticalTabsState === 1
          ? "max-h-[1000px] opacity-100 z-2"
          : "opacity-0 max-h-0 z-0"
      }`}
    >
      <p className="mb-[25px] text-[16px] leading-[28px]">
        Send clear and complete quotations to your prospects. Add product
        descriptions, beautiful images, and additional information simply by
        dragging and dropping building blocks.
      </p>

      <ul className="text-[16px] mb-[10px] ml-[40px] marker:text-[16px] list-disc">
        <li className="my-[10px] text-[14px]">Modern User Interface</li>
        <li className="my-[10px] text-[14px]">Quotation Builder</li>
        <li className="my-[10px] text-[14px]">Sales Orders</li>
        <li className="my-[10px] text-[14px]">
          Manage Invoicing from Sales Orders
        </li>
        <li className="my-[10px] text-[14px]">Contracts</li>
        <li className="my-[10px] text-[14px]">Customer Portal</li>
        <li className="my-[10px] text-[14px]">Schedule Activities</li>
        <li className="my-[10px] text-[14px]">On-Boarding Emails</li>
        <li className="my-[10px] text-[14px]">Multi-Companies Rules</li>
        <li className="my-[10px] text-[14px]">Product Variants</li>
        <li className="my-[10px] text-[14px]">Discounts</li>
        <li className="my-[10px] text-[14px]">Product Types</li>
        <li className="my-[10px] text-[14px]">Pricelists</li>
        <li className="my-[10px] text-[14px]">Coupons</li>
        <li className="my-[10px] text-[14px]">Order & Invoicing Analysis</li>
        <li className="my-[10px] text-[14px]">Trackable KPIs</li>
        <li className="my-[10px] text-[14px]">
          Full Overview Of All Your Sales Activities
        </li>
      </ul>
    </div>
  );
}
